import { Box, Avatar, Stack, Typography, Paper, useTheme } from '@mui/material'
import StatusBtn from '../../atoms/status/StatusBtn'
import { styled } from '@mui/material/styles'
import React from 'react'
import TableData from '../../atoms/table/TableData'
import { statusData } from '../../../util/constants'

const StyledTableHeader = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.grey[50],
	borderRadius: '8px 8px 0 0',
	padding: '12px 24px',
	borderBottom: `1px solid ${theme.palette.grey[200]}`,
}))

const StyledTableRow = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: '16px 24px',
	borderBottom: `1px solid ${theme.palette.grey[200]}`,
	'&:last-child': {
		borderBottom: 'none',
		borderRadius: '0 0 8px 8px',
	},
	'&:hover': {
		backgroundColor: theme.palette.grey[50],
	},
}))

export default function UpcomingWeddingsTable({ rows = [], dateLabel = "Date" }) {
	const theme = useTheme()

	const columns = [
		{
			field: 'Couple',
			headerName: 'Couple',
			flex: 2,
			minWidth: 200,
			renderCell: (params) => (
				<Stack direction="row" alignItems="center" spacing={2}>
					<Avatar
						src={params.row.avatar}
						alt={params.value}
						sx={{ width: 40, height: 40 }}
					/>
					<Typography
						variant="body2"
						fontWeight={500}
						color="text.primary"
					>
						{params.value}
					</Typography>
				</Stack>
			),
		},
		{
			field: 'Date',
			headerName: dateLabel,
			flex: 1,
			minWidth: 120,
			renderCell: (params) => (
				<Typography variant="body2" color="text.secondary">
					{params.value}
				</Typography>
			),
		},
		{
			field: 'Budget',
			headerName: 'Budget',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => (
				<Typography
					variant="body2"
					color="text.primary"
					fontWeight={500}
				>
					{params.value}
				</Typography>
			),
		},
		{
			field: 'Status',
			headerName: 'Status',
			flex: 1,
			minWidth: 100,
			renderCell: (params) => {
				const status = statusData.find(
					(item) => item.status === params.value
				)
				return (
					<StatusBtn
						size="small"
						label={params.value}
						variant={status?.variant || 'default'}
					/>
				)
			},
		},
	]

	return (
		<div style={{ gridTemplateColumns: '1fr 1fr' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					// height: 'calc(100vh - 420px)',
					// height: '100%',
					// minHeight: 200,
					'@media (max-width: 900px)': {
						// height: 'calc(100vh - 390px)',
					},
				}}
			>
				<Box sx={{ flex: 1, minHeight: 0 }}>
					<TableData
						hideFooter={true}
						rows={rows}
						columns={columns}
						height="320px"
						checkboxSelection={false}
						sx={
							{
								// height: 'calc(100dvh - 200px)',
								// '@media (max-width: 768px)': {
								// 	height: 'calc(100dvh - 260px)',
								// },
							}
						}
					/>
				</Box>
			</Box>
		</div>
	)
}
